import { CanvasToolbarEnum } from 'enums';

export const fontFamilyOptions = [
  {
    name: 'Arial',
    family: 'arial',
  },
  {
    name: 'Times New Roman',
    family: 'TimesNewRoman',
  },
  {
    name: 'Francois One',
    family: 'francois_oneregular',
  },
  {
    name: 'Georgia',
    family: 'georgia',
  },
  {
    name: 'Roboto Slab',
    family: 'roboto_slabregular',
  },
  {
    name: 'Museo Slab',
    family: 'museo_slab500',
  },
  {
    name: 'Signika',
    family: 'signikaregular',
  },
  {
    name: 'Nunito',
    family: 'nunitoregular',
  },
  {
    name: 'Miso',
    family: 'misoregular',
  },
  {
    name: 'Caviar Dreams',
    family: 'caviar_dreamsregular',
  },
  {
    name: 'Bree Serif',
    family: 'breeserifregular',
  },
  {
    name: 'Grand Hotel',
    family: 'grandhotelregular',
  },
  {
    name: 'Oleo Script',
    family: 'oleoscriptregular',
  },
  {
    name: 'Comfortaa',
    family: 'comfortaaregular',
  },
  {
    name: 'Merriweather',
    family: 'merriweatherregular',
  },
  {
    name: 'Questrial',
    family: 'questrialregular',
  },
  {
    name: 'Open Sans',
    family: 'open_sansregular',
  },
];

export const fontFamilyVariations = [
  'museo_slab500',
  'francois_oneregular',
  'roboto_slabbold',
  'roboto_slabregular',
  'caviar_dreamsbold_italic',
  'caviar_dreamsregular',
  'caviar_dreamsitalic',
  'caviar_dreamsbold',
  'misobold',
  'misoregular',
  'nunitobold',
  'nunitoregular',
  'signikabold',
  'signikaregular',
  'breeserifregular',
  'comfortaaregular',
  'comfortaabold',
  'grandhotelregular',
  'merriweatherregular',
  'merriweatherbold',
  'merriweatheritalic',
  'merriweatherbold_italic',
  'oleoscriptregular',
  'oleoscriptbold',
  'questrialregular',
  'open_sansregular',
  'open_sansitalic',
  'open_sansbold_italic',
  'open_sansbold',
];

export const fontSizeOptions = [
  '1',
  '2',
  '4',
  '6',
  '8',
  '10',
  '12',
  '14',
  '16',
  '18',
  '20',
  '22',
  '24',
  '26',
  '28',
  '30',
  '32',
  '34',
  '36',
  '38',
  '40',
  '42',
  '44',
  '46',
  '48',
  '50',
  '52',
  '54',
  '56',
  '58',
  '60',
  '62',
  '64',
  '66',
  '68',
  '70',
  '72',
  '74',
  '76',
  '78',
  '80',
  '82',
  '84',
  '86',
  '88',
  '90',
  '92',
  '94',
  '96',
  '98',
  '100',
  '200',
  '300',
  '400',
  '500',
  '600',
  '700',
];

export function calculateFontSize(object) {
  if (!object) {
    return;
  }
  if (!object.isEditing) {
    return;
  }

  if (!object.getSelectionStyles().length) {
    // Selection is at cursor position
    return object.getStyleAtPosition(object.selectionStart).fontSize || object.fontSize;
  }

  // Selection is a highlighted area
  const selectionStyles = object.getSelectionStyles();
  // build an array with all font sizes
  const fontSizes = [];

  for (let i = 0; i < selectionStyles.length; i++) {
    fontSizes.push(selectionStyles[i].fontSize);
  }

  if (!fontSizes.length) {
    // font size is the object's default
    return object.fontSize;
  }

  // check if all font sizes are the same
  for (let i = 0; i < fontSizes.length; i++) {
    if (fontSizes[i] !== fontSizes[0]) {
      return;
    }
  }

  return fontSizes[0];
}

/**
 * Extracts font families that need to be loaded from slide content,
 * including those applied at the character level in text objects.
 *
 * @param {Object} content - The slide content object containing elements.
 * @param {string[]} loadedFonts - Fonts that are already loaded.
 * @returns {string[]} - Font families to be loaded.
 */
export function getSlideFontsToLoad(content, loadedFonts) {
  if (content.objects) {
    const fontFamilies = content.objects.reduce((acc, obj) => {
      if (obj && obj.type) {
        // For text objects, check both top-level and character-level font families
        if (obj.type === CanvasToolbarEnum.TEXT) {
          // Add top-level fontFamily if not loaded
          if (
            obj.fontFamily &&
            !loadedFonts.includes(obj.fontFamily) &&
            !acc.includes(obj.fontFamily)
          ) {
            acc.push(obj.fontFamily);
          }
          // Add character-level fontFamilies from styles
          if (obj.styles && typeof obj.styles === 'object') {
            Object.values(obj.styles).forEach((line) => {
              if (typeof line === 'object') {
                Object.values(line).forEach((style) => {
                  if (
                    style &&
                    style.fontFamily &&
                    !loadedFonts.includes(style.fontFamily) &&
                    !acc.includes(style.fontFamily)
                  ) {
                    acc.push(style.fontFamily);
                  }
                });
              }
            });
          }
        }

        // For group objects, recurse
        if (obj.type === CanvasToolbarEnum.GROUP) {
          acc.push(...getSlideFontsToLoad(obj, [...loadedFonts, ...acc]));
        }
      }

      return acc;
    }, []);

    return fontFamilies;
  }

  return [];
}
